"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormType = void 0;
var FormType;
(function (FormType) {
    FormType[FormType["NA"] = 0] = "NA";
    FormType[FormType["Pardot"] = 1] = "Pardot";
    FormType[FormType["ServiceCloud"] = 2] = "ServiceCloud";
    FormType[FormType["Distributors"] = 3] = "Distributors";
    FormType[FormType["DpsDistributors"] = 4] = "DpsDistributors";
})(FormType || (exports.FormType = FormType = {}));
